import React from "react";

export function Field({ label, children, testid }) {
  return (
    <label className="block" data-testid={testid}>
      <span className="label block mb-1">{label}</span>
      {children}
    </label>
  );
}

export function AssignmentRow({ label, users, value, onChange, testid }) {
  return (
    <div className="flex items-center justify-between gap-3" data-testid={testid}>
      <div className="label text-xs whitespace-nowrap">{label}</div>
      <select className="input-box text-xs flex-1" value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="">— unassigned —</option>
        {users.map(u => <option key={u.id} value={u.id}>{`${u.name} · ${u.email}`}</option>)}
      </select>
    </div>
  );
}

// ===== Design Tab =====

export function computeAggregates(arrays) {
  if (!arrays.length) return null;
  const totalModules = arrays.reduce((s, a) => s + (Number(a.numberOfModules) || 0), 0);
  const totalKwp = arrays.reduce((s, a) => s + (Number(a.numberOfModules) || 0) * (Number(a.moduleWattage) || 0) / 1000, 0);
  const totalAnnual = arrays.reduce((s, a) => s + (Number(a.annualEnergyProduction) || 0), 0);
  const specific = totalKwp > 0 ? totalAnnual / totalKwp : 0;
  const avgW = totalModules > 0
    ? arrays.reduce((s, a) => s + (Number(a.moduleWattage) || 0) * (Number(a.numberOfModules) || 0), 0) / totalModules : 0;
  const avgTilt = totalModules > 0
    ? arrays.reduce((s, a) => s + (Number(a.tilt) || 0) * (Number(a.numberOfModules) || 0), 0) / totalModules : 0;
  const avgAzimuth = totalModules > 0
    ? arrays.reduce((s, a) => s + (Number(a.azimuth) || 0) * (Number(a.numberOfModules) || 0), 0) / totalModules : 0;
  return {
    numberOfModules: totalModules,
    systemSize: +totalKwp.toFixed(2),
    annualEnergyProduction: Math.round(totalAnnual),
    specificYield: +specific.toFixed(1),
    moduleWattage: +avgW.toFixed(1),
    moduleModel: arrays.find(a => a.moduleModel)?.moduleModel || "",
    tilt: +avgTilt.toFixed(1),
    azimuth: +avgAzimuth.toFixed(1),
  };
}

